// 必须得将 css 文件引入进来，这样才能打包进去
import './index.less'
import {
    isHelpChooseOpen,
    getMainScene,
    addOtherMainScene,
    getSubScene,
    getElectrical,
    getBothGoods,
    getBothGoodsPrice,
    getResultSingleGoods,
    getResultGoodsList,
    getProductWarrantyInfo,
} from '@utils/fetch.js'
import { addItem } from '@shopify/theme-cart';
import { formatMoney } from '@shopify/theme-currency'


document.addEventListener("DOMContentLoaded", async () => {
    // 判断 智能选购 功能 有没开启
    const { data } = await isHelpChooseOpen()
    if (data) {
        initStartChoose()
    } else {
        window.location.href = "/"
    }
})

class BaseChoose {
    constructor({prevEl, el, nextEl, btnConfig = {}}) {
        const { backBtn, backBtnCallback, nextBtn, nextBtnCallback, } = btnConfig

        this.prevDOM = this.prevDOM || this.$$(prevEl)
        this.DOM = this.DOM || this.$$(el)
        this.nextDOM = this.nextDOM || this.$$(nextEl)
        this.backBtn = this.backBtn || this.$$(backBtn)
        this.nextBtn = this.nextBtn || this.$$(nextBtn)

        // title DOM
        this.titleDOM = this.titleDOM || this.$$('[data-title]')

        // 清楚全部 按钮
        this.clearAllBtn = this.clearAllBtn || this.$$('[data-clear-all]')

        if (this.backBtn) {
            this.backBtn.onclick = () => this.btnClickHook('back', backBtnCallback)
        }
        if (this.nextBtn) {
            this.nextBtn.onclick = () => this.btnClickHook('next', nextBtnCallback)
        }
    }
    $$(entity) {
        return entity ? document.querySelector(entity) : null
    }
    // 数据埋码
    GAEvent(params) {
        window.dataLayer.push({ "event_parameters": null });
        window.dataLayer.push({
            "event":"ga4Event",
            "event_name":"how_to_choose",
            "event_parameters":{
                "current_page": window.location.href, // current page url
                ...params
            }
        });
    }
    btnClickHook(btnType, callback) {
        if (btnType === 'back') {
            this.prevDOM && (this.prevDOM.style.display = 'block')
            this.DOM && (this.DOM.style.display = 'none')
        }
        if (btnType === 'next') {
            this.nextDOM && (this.nextDOM.style.display = 'block')
            this.DOM && (this.DOM.style.display = 'none')
        }
        this.scrollToHelpMeDOM()

        callback && callback()
    }
    // 更新 step
    updateStep(step = 1, direction) {
        const activeStep = this.$$('[data-step-active]')
        if (direction === 'prev') {
            const prevEle = activeStep.previousElementSibling
            if (prevEle) {
                activeStep.classList.remove('active')
                activeStep.classList.remove('finish')
                activeStep.removeAttribute('data-step-active')
                prevEle.classList.add('active')
                prevEle.classList.remove('finish')
                prevEle.setAttribute('data-step-active', '')
            }
        }
        if (direction === 'next') {
            const nextEle = activeStep.nextElementSibling
            if (nextEle) {
                activeStep.classList.remove('active')
                activeStep.classList.add('finish')
                activeStep.removeAttribute('data-step-active')
                nextEle.classList.add('active')
                nextEle.setAttribute('data-step-active', '')
            }
        }

        // 更新 页面 title
        const titleArray = this.titleDOM.dataset.titleString.split(',')
        this.titleDOM.innerHTML = titleArray[step - 1]
    }
    // 滚动到 动态内容 DOM
    scrollToHelpMeDOM(callback) {
        const helpMeOffsetTop = this.$$('#shopify-section-page-help-me').offsetTop
        const headerHeight =this.$$('.site-header')?.offsetHeight || this.$$('jky-header')?.offsetHeight
        window.scrollTo({
            top: helpMeOffsetTop - headerHeight,
            behavior: 'smooth',
        })
        callback && callback()
    }
    // 注册监听事件
    addEventListener(el, event, fn) {
        const target = el ? document.querySelector(el) : window
        target.addEventListener(event, fn.bind(this))
    }
    // 移除监听事件
    removeEventListener(el, event, fn) {
        const target = el ? document.querySelector(el) : window
        target.removeEventListener(event, fn.bind(this))
    }
    matchContent(param) {

        const RegExp = /\[([^\]]*)\]/ // 摘取 [] 内的内容
        const result = param.match(RegExp)
        return result ? result[1] : ''
    }
    // 获取商品延保信息
    async getProductWarranty(id) {
        try {
            const { data: { productWarranty, } } = await getProductWarrantyInfo({ skuId: id, })
           
            const warrantyKey = `${howToChoose.warrantyKey}`
            const warrantyContent = `${howToChoose.warrantyContent}`
            let warrantyProperty = Object.create(null)
            if (productWarranty) {
                warrantyProperty[warrantyKey] = warrantyContent
            }

            return warrantyProperty
        } catch {
            return Object.create(null)
        }
    }
    // 加入购物车
    async addToCart(id, quantity = 1, properties = {}) {
        const warrantyProperty = await this.getProductWarranty(id)

        let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        addItem(id, {
            quantity,
            properties: {
                SmartShopOrder: '',
                // ...warrantyProperty, 暂时不需要再购物车展示延保信息
                ...properties,
            },
        }).then(response => {
            cart.renderContents(response)
        })
        .catch((e) => {
            console.error(e);
        })
        .finally(() => {
            if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty')

            document.querySelectorAll('[data-advantage-add-to-cart]').forEach( it => it.classList.remove('btn--loading'))
            document.querySelectorAll('[data-end-add-to-cart]').forEach( it => it.classList.remove('btn--loading'))
        });
    }
    // buy now
    async buyNow(id) {
        const params = { SmartShopOrder: '', }
        try {
            //暂时不需要再购物车展示延保信息
            // const warrantyProperty = await this.getProductWarranty(id)

            // const properties =
            //     Object.keys(warrantyProperty).length !== 0
            //         ? window.btoa(unescape(encodeURIComponent(JSON.stringify({ ...warrantyProperty, ...params, }))))
            //         : window.btoa(unescape(encodeURIComponent(JSON.stringify({ ...params, }))))


            const properties = window.btoa(unescape(encodeURIComponent(JSON.stringify({ ...params, }))))
            window.location.href = `/cart/${id}:1?traffic_source=buy_now&properties=${properties}`
        } finally {
            document.querySelectorAll('[data-end-buy-now]').forEach( it => it.classList.remove('btn--loading'))
        }
    }
}


// 开始选择
class StartChoose extends BaseChoose {
    constructor({ ...props }) {
        super({ ...props })

        // 数据埋码 - Product Compare
        document.querySelector('[data-smart-shop-compare-link]').onclick = e => {
            const wrap = document.querySelector('[data-smart-shop-compare-wrap]')

            const position = wrap.querySelector('h2').innerText
            const button_name = e.target.nodeName === 'A' ? e.target.innerText : e.target.parentElement.innerText
            const link = e.target.nodeName === 'A' ? e.target.getAttribute('href') : e.target.parentElement.getAttribute('href')
            this.GAEvent({
                module: 'sing_pic',
                position,
                button_name,
                link,
            })
        }

        this.init()
    }
    async init() {
        const { data = [] } = await getMainScene()
        const mainSceneDOM = this.$$('[data-main-scene]')
        const { otherText, otherPcImg, otherMbImg, } = mainSceneDOM.dataset

        let html = ''
        data.forEach(({ sceneMainId, sceneMainImageMobile, sceneMainImagePc, sceneMainName }, index) => {
            html += `
                <li
                    class="group ${index === 0 ? 'active' : ''} py-50 lg:j-py-20 cursor-pointer flex-shrink-0"
                    data-tab-id="${sceneMainId}"
                    data-tab="${sceneMainName}"
                    data-mb-img="${sceneMainImageMobile}"
                    data-pc-img="${sceneMainImagePc}"
                >
                    <span class="choose-tab">${sceneMainName}</span>
                </li>
            `
        })
        // 固定
        html += `
            <li
                class="group py-50 lg:j-py-20 cursor-pointer flex-shrink-0"
                data-tab-id=""
                data-tab="${otherText}"
                data-mb-img="${otherMbImg}"
                data-pc-img="${otherPcImg}"
            >
                <span class="choose-tab">${otherText}</span>
            </li>
        `
        mainSceneDOM.innerHTML = html

        this.tabs = this.DOM.querySelectorAll('[data-tab]') || []
        this.tabs.forEach(it => it.onclick = () => this.handleTabClick(it, otherText))

        // 默认激活第一个 tab
        this.handleTabClick(this.tabs[0], otherText)
    }
    handleTabClick(it, otherText) {
        this.tabs.forEach(v => v.classList.remove('active'))
        it.classList.add('active')

        const { mbImg, pcImg, tab, tabId, } = it.dataset

        const tabContentDom = this.$$('[data-tab-content]')
        tabContentDom.innerHTML = `
            <img loading="lazy" class="block lg:hidden w-full h-[100vw] object-cover" src="${mbImg}" alt="">
            <img loading="lazy" class="hidden lg:block w-full lg:j-h-560 object-cover" src="${pcImg}" alt="">
        `

        this.sceneMainName = tab
        this.sceneMainId = tabId
        this.$$('[data-tab-others]').style.display = this.sceneMainName === otherText ? 'block' : 'none'
    }
}
function initStartChoose() {
    const startchoose = new StartChoose({
        el: '#start',
        nextEl: '#question1',
        btnConfig: {
            nextBtn: '[data-start-next]',
            nextBtnCallback: () => {
                // 数据埋码
                const title = document.querySelector('[data-title]').innerText
                startchoose.GAEvent({
                    module: title,
                    position: startchoose.sceneMainName,
                })

                startchoose.updateStep(1)

                // 初始化 选择场景
                const chooseScenarios = initChooseScenarios(startchoose.sceneMainName, startchoose.sceneMainId)
                const { otherText, }= document.querySelector('[data-main-scene]')?.dataset || {}
                if (startchoose.sceneMainName === otherText) {
                    const inputVal = document.querySelector('[data-other-scene-input]')?.value?.trim()
                    inputVal && addOtherMainScene({ scene: inputVal })
                    chooseScenarios.nextBtn.onclick()
                }
            },
        },
    })
}


// 1 - 选择场景
class ChooseScenarios extends BaseChoose {
    constructor({ sceneMainName, sceneMainId, ...props }) {
        super(props)

        if (sceneMainId) {
            this.sceneSubIdList = []
            this.nextBtn.disabled = true

            const choosedScenarios = this.DOM.querySelector('[data-scenarios]')
            choosedScenarios.innerHTML = sceneMainName

            this.$$('[data-sub-scene]').innerHTML = this.renderSkeleton()

            this.init(sceneMainId)
        }
    }
    async init(sceneMainId) {
        const { data = [] } = await getSubScene({ sceneMainId, })

        this.$$('[data-sub-scene]').innerHTML = this.renderScene(data)

        this.sceneCheckboxes = this.DOM.querySelectorAll('[data-scene-checkbox]') || []
        this.sceneCheckboxes.forEach(it => {
            it.checked = false
            it.onclick = () => this.chooseScene()
        })
    }
    renderSkeleton() {
        return `
            <li class="flex-center flex-col">
                <div class="w-296 h-341 lg:j-w-206 lg:j-h-187 rounded-30 lg:j-rounded-30 bg-[#EEE] skeleton"></div>
                <div class="w-200 h-48 lg:j-w-150 lg:j-h-35 mt-16 lg:j-mt-12 bg-[#EEE] skeleton"></div>
            </li>
            <li class="flex-center flex-col">
                <div class="w-296 h-341 lg:j-w-206 lg:j-h-187 rounded-30 lg:j-rounded-30 bg-[#EEE] skeleton"></div>
                <div class="w-200 h-48 lg:j-w-150 lg:j-h-35 mt-16 lg:j-mt-12 bg-[#EEE] skeleton"></div>
            </li>
            <li class="flex-center flex-col">
                <div class="w-296 h-341 lg:j-w-206 lg:j-h-187 rounded-30 lg:j-rounded-30 bg-[#EEE] skeleton"></div>
                <div class="w-200 h-48 lg:j-w-150 lg:j-h-35 mt-16 lg:j-mt-12 bg-[#EEE] skeleton"></div>
            </li>
            <li class="flex-center flex-col">
                <div class="w-296 h-341 lg:j-w-206 lg:j-h-187 rounded-30 lg:j-rounded-30 bg-[#EEE] skeleton"></div>
                <div class="w-200 h-48 lg:j-w-150 lg:j-h-35 mt-16 lg:j-mt-12 bg-[#EEE] skeleton"></div>
            </li>
            <li class="flex-center flex-col">
                <div class="w-296 h-341 lg:j-w-206 lg:j-h-187 rounded-30 lg:j-rounded-30 bg-[#EEE] skeleton"></div>
                <div class="w-200 h-48 lg:j-w-150 lg:j-h-35 mt-16 lg:j-mt-12 bg-[#EEE] skeleton"></div>
            </li>
            <li class="flex-center flex-col">
                <div class="w-296 h-341 lg:j-w-206 lg:j-h-187 rounded-30 lg:j-rounded-30 bg-[#EEE] skeleton"></div>
                <div class="w-200 h-48 lg:j-w-150 lg:j-h-35 mt-16 lg:j-mt-12 bg-[#EEE] skeleton"></div>
            </li>
            <li class="flex-center flex-col">
                <div class="w-296 h-341 lg:j-w-206 lg:j-h-187 rounded-30 lg:j-rounded-30 bg-[#EEE] skeleton"></div>
                <div class="w-200 h-48 lg:j-w-150 lg:j-h-35 mt-16 lg:j-mt-12 bg-[#EEE] skeleton"></div>
            </li>
        `
    }
    renderScene(data = []) {
        let html = ''
        data.forEach(({ sceneSubId, sceneSubImage, sceneSubName, }, index) => {
            html += `
                <li>
                    <div class="relative cursor-pointer">
                        <input
                            type="checkbox"
                            id="scene-${index}"
                            data-id="${sceneSubId}"
                            data-name="${sceneSubName}"
                            data-scene-checkbox
                            class="input-checkbox choose-checkbox"
                        />
                        <label for="scene-${index}" class="cursor-pointer">
                            <img
                                loading="lazy"
                                class="w-296 h-341 lg:j-w-206 lg:j-h-187 object-cover rounded-30 lg:j-rounded-30"
                                src="${sceneSubImage}"
                            />
                        </label>
                    </div>
                    <h3 class="choose-checkbox-title">${sceneSubName}</h3>
                </li>
            `
        })
        return html
    }
    chooseScene() {
        this.sceneSubIdList = Array.from(this.sceneCheckboxes).map(it => it.checked && it.dataset.id).filter(Boolean)
        this.nextBtn.disabled = !this.sceneSubIdList.length
    }
}
function initChooseScenarios(sceneMainName, sceneMainId) {
    const chooseScenarios = new ChooseScenarios({
        sceneMainName,
        sceneMainId,

        prevEl: '#start',
        el: '#question1',
        nextEl: '#question2',
    
        btnConfig: {
            backBtn: '[data-question1-back]',
            backBtnCallback: () => {
                chooseScenarios.updateStep(1, 'prev')
            },
            nextBtn: '[data-question1-next]',
            nextBtnCallback: () => {
                //  数据埋码
                const title = document.querySelector('[data-title]').innerText
                const scenarios = document.querySelector('[data-scenarios]').innerText
                const sceneBoxes = chooseScenarios.DOM.querySelectorAll('[data-scene-checkbox]')
                Array.from(sceneBoxes).forEach(it => {
                    if (it.checked) {
                        const text = it.parentElement.nextElementSibling.innerText
                        chooseScenarios.GAEvent({
                            module: title,
                            position: scenarios,
                            button_name: text,
                        })
                    }
                })

                chooseScenarios.updateStep(2, 'next')
    
                // 初始化 选择电器
                initChooseAppliances(sceneMainId, chooseScenarios.sceneSubIdList, chooseScenarios)
            },
        },
    })
    return chooseScenarios
}


// 2 - 选择电器
class ChooseAppliances extends BaseChoose {
    constructor({ sceneMainId, sceneSubIdList, fixedEditPopup, editPopupConfig, ...props }) {
        super(props)

        this.fixedEditPopup = this.$$(fixedEditPopup)
        
        this.appliancesInitData = []
        this.electricalIdList = []
        
        this.totalEnergy = 0
        this.updateTotalEnergy(this.totalEnergy)

        this.nextBtn.disabled = true
        this.clearAllBtn.style.display = 'block'
        this.clearAllBtn.onclick = () => this.clearAll()

        this.electricList = this.$$('[data-electric-list]')
        this.electricList.innerHTML = this.renderSkeleton()

        this.initDOM(sceneMainId, sceneSubIdList, editPopupConfig)
    }
    // 初始化DOM
    async initDOM(sceneMainId, sceneSubIdList, editPopupConfig) {
        const { data = [] } = await getElectrical({ sceneMainId, sceneSubIdList, })

        this.electricList.innerHTML = this.renderElectric(data)

        this.applianceCheckBoxes = this.DOM.querySelectorAll('[data-appliance-checkbox]') || []
        this.applianceCheckBoxes.forEach(it => {
            it.checked = false
            const { name, power, hours, mins, } = it.parentNode.parentNode.dataset
            this.appliancesInitData.push({
                name,
                power,
                hours,
                mins,
            })
            it.onclick = () => this.handleChoosed(it)
        })

        this.initEvents(editPopupConfig)
    }
    renderSkeleton() {
        return `
            <li class="w-full h-150 lg:j-h-92 bg-[#EEE] skeleton"></li>
            <li class="w-full h-150 lg:j-h-92 bg-[#EEE] skeleton"></li>
            <li class="w-full h-150 lg:j-h-92 bg-[#EEE] skeleton"></li>
            <li class="w-full h-150 lg:j-h-92 bg-[#EEE] skeleton"></li>
            <li class="w-full h-150 lg:j-h-92 bg-[#EEE] skeleton"></li>
            <li class="w-full h-150 lg:j-h-92 bg-[#EEE] skeleton"></li>
            <li class="w-full h-150 lg:j-h-92 bg-[#EEE] skeleton"></li>
            <li class="w-full h-150 lg:j-h-92 bg-[#EEE] skeleton"></li>
            <li class="w-full h-150 lg:j-h-92 bg-[#EEE] skeleton"></li>
            <li class="w-full h-150 lg:j-h-92 bg-[#EEE] skeleton"></li>
        `
    }
    renderElectric(data = []) {
        const { editText } = this.electricList.dataset
        let html = ''
        data.forEach(({electricName, electricImage, electricalId, parameter, power, serviceTimeHours, serviceTimeMinute}, index) => {
            html += `
                <li
                    class="flex-between bg-white px-40 lg:j-px-30 border border-info border-solid rounded-30 lg:rounded-none lg:border-none"
                    data-name="${electricName}"
                    data-icon="${electricImage}"
                    data-power="${power}"
                    data-hours="${serviceTimeHours}"
                    data-mins="${serviceTimeMinute}"
                >
                    <label class="flex-1 flex items-center cursor-pointer py-40 lg:j-py-21" for="appliance-${index}">
                        <img loading="lazy" class="w-70 h-70 lg:j-w-50 lg:j-h-50 object-contain" src="${electricImage}" alt="" />
                        <div class="flex flex-col ml-40 lg:j-ml-20">
                            <h4 class="text-28 leading-36 lg:j-text-18 lg:j-leading-27 font-500 text-main lg:text-black mb-1">${electricName}</h4>
                            <p class="text-24 leading-36 lg:j-text-14 lg:j-leading-21 font-500 text-info" data-appliance-info>${parameter}</p>
                        </div>
                    </label>
                    <div class="flex">
                        <button
                            class="appearance-none bg-transparent text-32 leading-48 lg:j-text-18 lg:j-leading-27 font-300 text-primary mr-20 lg:j-mr-18"
                            data-edit
                        >${editText}</button>
                        <input
                            type="checkbox"
                            id="appliance-${index}"
                            data-id="${electricalId}"
                            data-appliance-checkbox
                            class="input-checkbox choose-appliance-checkbox"
                        />
                    </div>
                </li>
            `
        })
        // 固定 custome appliance DOM
        html += `
            <li
                class="flex-between bg-white px-40 lg:j-px-30 border border-info border-solid rounded-30 lg:rounded-none lg:border-none"
                data-custom-appliance
                data-name="${howToChoose.customAppliance}"
                data-icon="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/CustomAppliance.png?v=1678952056"
                data-power="0"
                data-hours="0"
                data-mins="0"
            >
                <label class="flex-1 flex items-center cursor-pointer py-40 lg:j-py-21" for="appliance-custom">
                    <img loading="lazy" class="w-70 h-70 lg:j-w-50 lg:j-h-50 object-contain" src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/CustomAppliance.png?v=1678952056" alt="" />
                    <div class="flex flex-col ml-40 lg:j-ml-20">
                        <h4 class="text-28 leading-36 lg:j-text-18 lg:j-leading-27 font-500 text-main lg:text-black mb-1">${howToChoose.customAppliance}</h4>
                        <p class="text-24 leading-36 lg:j-text-14 lg:j-leading-21 font-500 text-info" data-appliance-info></p>
                    </div>
                </label>
                <div>
                    <button
                        data-appliance-add
                        class="
                            appearance-none bg-transparent
                            w-54 h-54 lg:j-w-32 lg:j-h-32 relative
                            before:block before:content-[''] before:w-full before:h-[1px] before:absolute before:left-0 before:top-1/2 before:bg-info
                            after:block after:content-[''] after:w-full after:h-[1px] after:absolute after:left-0 after:top-1/2 after:bg-info after:rotate-90
                        "
                    ></button>
                </div>
                <div class="hidden">
                    <button
                        class="appearance-none bg-transparent text-32 leading-48 lg:j-text-18 lg:j-leading-27 font-300 text-primary mr-20 lg:j-mr-18"
                        data-edit
                    >${editText}</button>
                    <input
                        type="checkbox"
                        id="appliance-custom"
                        data-appliance-checkbox
                        class="input-checkbox choose-appliance-checkbox"
                    />
                </div>
            </li>
        `
        return html
    }
    // 初始化 events
    initEvents(editPopupConfig) {
        const { addApplianceBtn, powerInput, hoursInput, minsInput, confirmEditBtn, } = editPopupConfig
        this.addApplianceBtn = this.$$(addApplianceBtn)
        this.powerInput = this.$$(powerInput)
        this.hoursInput = this.$$(hoursInput)
        this.minsInput = this.$$(minsInput)
        this.confirmEditBtn = this.$$(confirmEditBtn)

        // edit popup
        const editBtns = this.DOM.querySelectorAll('[data-edit]') || []
        editBtns.forEach(it => it.onclick = () => this.handleEditBtn('edit', it))

        this.addApplianceBtn.onclick = () => this.handleEditBtn('add', this.addApplianceBtn)

        this.confirmEditBtn.onclick = () => this.confirmPopupData()
    }
    handleChoosed(it) {
        const { name, power, hours, mins, } = it.parentNode.parentNode.dataset
        const addApplianceBtnDisplay = this.addApplianceBtn.style.display
        if (name === `${howToChoose.customAppliance}` && addApplianceBtnDisplay !== 'none') {
            it.checked = false
        }

        if (it.checked) {
            this.totalEnergy += this.calcChoosedPower(power, hours, mins)
            this.updateTotalEnergy(this.totalEnergy)
        } else {
            this.totalEnergy -= this.calcChoosedPower(power, hours, mins)
            this.updateTotalEnergy(this.totalEnergy)
        }

        this.electricalIdList = Array.from(this.applianceCheckBoxes).map(it => it.checked && it.dataset.id).filter(Boolean)
        this.nextBtn.disabled = !this.electricalIdList.length
    }
    // 编辑 或 新增
    handleEditBtn(action, it) {
        this.fixedEditPopup.style.display = 'block'

        const mask = this.fixedEditPopup.querySelector('[data-mask]')
        const closeBtn = this.fixedEditPopup.querySelector('[data-close]')
        mask.onclick = () => this.hideFixedEditPopup()
        closeBtn.onclick = () => this.hideFixedEditPopup()

        const popupTitleDOM = this.$$('[data-edit-popup-title]')
        const { name, icon, power, hours, mins, } = it.parentNode.parentNode.dataset
        this.editPopupName = name
        this.powerInput.value = power
        this.hoursInput.value = hours
        this.minsInput.value = mins

        this.popupAction = action
        popupTitleDOM.innerHTML = `
            <img class="w-80 h-80 lg:j-w-68 lg:j-h-68 object-contain" src="${icon}" alt="" />
            <span class="text-36 leading-54 font-600 text-main lg:j-text-36 lg:j-leading-54">${name}</span>
        `

        this.updateConfirmBtnStatus()

        this.addEventListener("[data-power-input]", "input", this.watchPowerInput)
        this.addEventListener("[data-hours-input]", "input", this.updateConfirmBtnStatus)
        this.addEventListener("[data-mins-input]", "input", this.updateConfirmBtnStatus)
    }
    watchPowerInput(e) {
        let value = e.target.value
        if(value<0) {
            value=0
        }
        if(value>3000) {
            this.$$('[data-power-input-info]').classList.add('hidden')
            this.$$('[data-power-input-error-tip]').classList.remove('hidden')
        } else {
            this.$$('[data-power-input-info]').classList.remove('hidden')
            this.$$('[data-power-input-error-tip]').classList.add('hidden')
        }
        e.target.value = value.replace(/\D|^[0]+/g,'')

        this.updateConfirmBtnStatus()
    }
    updateConfirmBtnStatus() {
        if (+this.powerInput.value && (+this.powerInput.value <= 3000) && (+this.hoursInput.value || +this.minsInput.value)) {
            this.confirmEditBtn.disabled = false
        } else {
            this.confirmEditBtn.disabled = true
        }

        if (+this.hoursInput.value === 24) {
            this.minsInput.value = 0
        }
    }
    hideFixedEditPopup() {
        this.fixedEditPopup.style.display = 'none'
        this.removeEventListener("[data-power-input]", "input", this.updateConfirmBtnStatus)
        this.removeEventListener("[data-hours-input]", "input", this.updateConfirmBtnStatus)
        this.removeEventListener("[data-mins-input]", "input", this.updateConfirmBtnStatus)
    }
    // 计算选中的电器瓦数
    calcChoosedPower(power, hours, mins) {
        const time = (+hours + +mins/60).toFixed(1)
        return (+power * +time)
    }
    updateTotalEnergy(energy) {
        this.$$('[data-total-energy]').innerHTML = energy.toFixed(1)
    }
    renderPowerInfo(power, hours, mins) {
        const w = +power ? `${power}` : ''
        const h = +hours ? +hours : 0
        const m = +mins ? +(+mins / 60).toFixed(1) : 0

        const { wattageUnit, hourUnit, dayUnit, } = this.fixedEditPopup.dataset

        return w ? [`${w}${wattageUnit}`, `${h+m}${hourUnit}`, `${dayUnit}`].filter(it => it.length > 0).join('/') : null
    }
    // 提交
    confirmPopupData() {
        const [ power, hours, mins, ] = [ this.powerInput.value, this.hoursInput.value, this.minsInput.value, ]
        this.applianceCheckBoxes.forEach(it => {
            const parentNodeLi = it.parentNode.parentNode

            const { name, power: oldPower, hours: oldHours, mins: oldMins, } = parentNodeLi.dataset
            if (name === this.editPopupName) {
                if (it.checked) {
                    this.totalEnergy -= this.calcChoosedPower(oldPower, oldHours, oldMins)
                    this.totalEnergy += this.calcChoosedPower(power, hours, mins)
                    this.updateTotalEnergy(this.totalEnergy)
                } else {
                    it.checked = true
                    this.totalEnergy += this.calcChoosedPower(power, hours, mins)
                    this.updateTotalEnergy(this.totalEnergy)
                }
                
                const applianceInfoDom = parentNodeLi.querySelector('[data-appliance-info]')
                applianceInfoDom.innerHTML = this.renderPowerInfo(power, hours, mins)

                parentNodeLi.setAttribute('data-power', power)
                parentNodeLi.setAttribute('data-hours', hours)
                parentNodeLi.setAttribute('data-mins', mins)

                if (this.popupAction === 'add') {
                    this.addApplianceBtn.style.display = 'none'
        
                    const nextElementSibling = this.addApplianceBtn.parentNode.nextElementSibling
                    nextElementSibling.style.display = 'flex'
                }
            }
        })
        this.nextBtn.disabled = false
        this.hideFixedEditPopup()
    }
    // 清空全部
    clearAll() {
        this.applianceCheckBoxes.forEach(it => {
            it.checked = false

            const parentNodeLi = it.parentNode.parentNode
            const { name, } = parentNodeLi.dataset
            const { power, hours, mins, } = this.appliancesInitData.find(it => it.name === name)
            const applianceInfoDom = parentNodeLi.querySelector('[data-appliance-info]')
            applianceInfoDom.innerHTML = this.renderPowerInfo(power, hours, mins)

            parentNodeLi.setAttribute('data-power', power)
            parentNodeLi.setAttribute('data-hours', hours)
            parentNodeLi.setAttribute('data-mins', mins)
        })

        this.addApplianceBtn.style.display = 'block'
        this.addApplianceBtn.parentNode.nextElementSibling.style.display = 'none'

        this.totalEnergy = 0
        this.updateTotalEnergy(this.totalEnergy)

        this.nextBtn.disabled = true
    }
}
function initChooseAppliances(sceneMainId, sceneSubIdList, chooseScenarios) {
    const chooseAppliances =  new ChooseAppliances({
        sceneMainId,
        sceneSubIdList,

        prevEl: '#question1',
        el: '#question2',
        nextEl: '#question3',
    
        btnConfig: {
            backBtn: '[data-question2-back]',
            backBtnCallback: () => {
                if (sceneMainId) {
                    chooseAppliances.updateStep(1, 'prev')
                } else {
                    chooseAppliances.updateStep(2, 'prev')
                    chooseScenarios.backBtn.click()
                }

                chooseAppliances.clearAllBtn.style.display = 'none'
            },
            nextBtn: '[data-question2-next]',
            nextBtnCallback: () => {
                //  数据埋码
                const title = document.querySelector('[data-title]').innerText
                const applianceBoxes = chooseAppliances.DOM.querySelectorAll('[data-appliance-checkbox]')
                Array.from(applianceBoxes).forEach(it => {
                    if (it.checked) {
                        const textDOM = it.parentElement.parentElement.querySelector('[data-appliance-info]')
                        const nameDOM = textDOM.previousElementSibling
                        chooseAppliances.GAEvent({
                            module: title,
                            position: nameDOM.innerText,
                            button_name: textDOM.innerText,
                        })
                    }
                })

                chooseAppliances.updateStep(3, 'next')

                chooseAppliances.clearAllBtn.style.display = 'none'
                // 初始化 选择优点
                initChooseAdvantages(chooseAppliances.totalEnergy)
            }
        },

        fixedEditPopup: '#fixed-edit-popup',

        editPopupConfig: {
            addApplianceBtn: '[data-appliance-add]',

            powerInput: '[data-power-input]',
            hoursInput: '[data-hours-input]',
            minsInput: '[data-mins-input]',

            confirmEditBtn: '[data-confirm-edit]',
        },
    })
    return chooseAppliances
}


// 3 - 选择优点
class ChooseAdvantages extends BaseChoose {
    constructor({ totalEnergy, fixedModelsPopup, ...props }) {
        super(props)

        this.totalEnergy = totalEnergy
        this.$$('[data-popup-total-energy]').innerHTML = this.totalEnergy

        this.advantageCheckboxes = this.DOM.querySelectorAll('[data-advantage-checkbox]') || []
        this.fixedModelsPopup = this.$$(fixedModelsPopup)

        this.init()
    }
    init() {
        this.advantageCheckboxes.forEach(it => {
            it.checked = true
            it.dataset.check = '1'

            it.onclick = () => this.chooseAdvantage(it)
        })

        const openModlesBtn = this.$$('[data-open-models]')
        openModlesBtn.onclick = (e) => {
            this.handleOpenModelBtn()

            // 当前页面标题
            const title = document.querySelector('[data-title]').innerText

            // 数据埋码
            this.GAEvent({
                module: title,
                position: e.target.dataset.openModelsText,
            })
        }
    }
    async handleOpenModelBtn() {
        const { recommendedName, deluxeName, } = this.fixedModelsPopup.dataset

        this.$$('[data-popup-result]').innerHTML = this.renderSkeleton(recommendedName, deluxeName)
        this.fixedModelsPopup.style.display = 'block'
        

        const { data: { cusEnergyRespList = []}, } = await getResultSingleGoods({ totalPower: this.totalEnergy, }) || {}
        // 推荐款
        const rProduct = (cusEnergyRespList || []).filter(it => it.recommend === 'smart_shop_recommend')[0]
        const useRDay = ((rProduct?.storageCapacity || 0) * 0.8 / this.totalEnergy).toFixed(1)
        const recommendHTML = rProduct ? this.renderProduct(recommendedName, rProduct, useRDay) : this.renderPlaceholder(recommendedName)
        
        // 豪华款
        const dProduct = (cusEnergyRespList || []).filter(it => it.recommend === 'smart_shop_deluxe')[0]
        const useDDay = ((dProduct?.storageCapacity || 0) * 0.8 / this.totalEnergy).toFixed(1)
        const deluxeHTML = dProduct ? this.renderProduct(deluxeName, dProduct, useDDay) : this.renderPlaceholder(deluxeName)

        this.$$('[data-popup-result]').innerHTML = `
            ${recommendHTML}
            <div class="block lg:hidden w-full h-[1px] bg-input mt-70 mb-8"></div>
            ${deluxeHTML}
        `

        this.initOpenModelEvent()
    }
    renderSkeleton(recommendedName, deluxeName) {
        return `
            <li class="flex-[50%] rounded-20 lg:rounded-none bg-white">
                <div class="flex-center gap-8 lg:j-gap-20 lg:j-mb-4 text-primary">
                    <img loading="lazy" class="w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
                    <span class="text-32 leading-48 lg:j-text-24 lg:j-leading-36 font-300 lg:font-500">${recommendedName}</span>
                    <img loading="lazy" class="rotate-180 w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
                </div>
                <div class="flex-center flex-col">
                    <div class="w-full h-96 lg:j-h-65 bg-[#EEE] skeleton"></div>
                    <div class="w-315 h-190 lg:j-w-315 lg:j-h-190 mt-55 mb-36 lg:j-mt-40 lg:j-mb-36 bg-[#EEE] skeleton"></div>
                    <div class="w-270 h-36 lg:j-w-280 lg:j-h-36 bg-[#EEE] skeleton"></div>
                </div>
                <div class="w-300 h-66 lg:j-w-206 lg:j-h-48 mx-auto mt-50 lg:j-mt-40 bg-[#EEE] skeleton"></div>
            </li>
            <div class="block lg:hidden w-full h-[1px] bg-input mt-70 mb-8"></div>
            <li class="flex-[50%] rounded-20 lg:rounded-none bg-white">
                <div class="flex-center gap-8 lg:j-gap-20 lg:j-mb-4 text-primary">
                    <img loading="lazy" class="w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
                    <span class="text-32 leading-48 lg:j-text-24 lg:j-leading-36 font-300 lg:font-500">${deluxeName}</span>
                    <img loading="lazy" class="rotate-180 w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
                </div>
                <div class="flex-center flex-col">
                    <div class="w-full h-96 lg:j-h-65 bg-[#EEE] skeleton"></div>
                    <div class="w-315 h-190 lg:j-w-315 lg:j-h-190 mt-55 mb-36 lg:j-mt-40 lg:j-mb-36 bg-[#EEE] skeleton"></div>
                    <div class="w-270 h-36 lg:j-w-280 lg:j-h-36 bg-[#EEE] skeleton"></div>
                </div>
                <div class="w-300 h-66 lg:j-w-206 lg:j-h-48 mx-auto mt-50 lg:j-mt-40 bg-[#EEE] skeleton"></div>
            </li>
        `
    }
    renderProduct(type, product, useDeluxeDay) {
        const { dailyUsage, dayUnit, learnMore, } = this.fixedModelsPopup.dataset
        return `
            <li class="flex-[50%] rounded-20 lg:rounded-none bg-white">
                <div class="flex-center gap-8 lg:j-gap-20 lg:j-mb-4 text-primary">
                    <img loading="lazy" class="w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
                    <span class="text-32 leading-48 lg:j-text-24 lg:j-leading-36 font-300 lg:font-500">${type}</span>
                    <img loading="lazy" class="rotate-180 w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
                </div>
                <div class="flex-center flex-col">
                    <h2 class="w-full text-center text-32 leading-54 lg:j-text-24 lg:j-leading-36 font-500 text-main line-clamp-2 text-ellipsis" title="${product.goodsTitle}">${product.goodsTitle}</h2>
                    <div class="w-full flex-center mt-55 mb-25 lg:j-mt-40 lg:j-mb-28 relative">
                        <img loading="lazy" class="w-315 h-190 lg:j-w-315 lg:j-h-190 object-contain" src="${product.goodsImage}" alt="">
                        <span class="block text-20 leading-30 lg:j-text-18 lg:j-leading-27 text-primary bg-[rgba(253,80,0,0.1)] font-300 rounded-4 lg:j-rounded-4 px-12 py-4 lg:px-3 lg:py-1 absolute right-55 -top-8 lg:right-0 lg:top-0 lg:-translate-y-1/2 -translate-y-full">${dailyUsage} ${useDeluxeDay} ${dayUnit} *</span>
                    </div>
                    <p class="flex items-center gap-20 lg:j-gap-12">
                    <span class="text-36 leading-54 font-600 text-primary lg:j-text-36 lg:j-leading-54">${formatMoney(product.goodsPrice * 100, window?.pageInfo?.currency?.money_format)}</span>
                    ${product.goodsOriginalPrice
                        ? `<del class="text-24 leading-36 lg:j-text-18 lg:j-leading-27 font-300 text-sub">${formatMoney(product.goodsOriginalPrice * 100, window?.pageInfo?.currency?.money_format)}</del>`
                        : ''
                    }
                    </p>
                </div>
                <p class="flex-center mt-50 gap-30 lg:j-mt-40 lg:j-gap-24">
                    <a
                        class="choose-btn-back w-300 lg:j-w-206 px-0 font-700 lg:font-600"
                        href="${product.goodsDetailUrl}"
                        data-advantage-learn-more
                        data-goods-title="${product.goodsTitle}"
                        target="_blank"
                    >${learnMore} <i class="iconfont jackery-icon-arrow-right"></i></a>
                    <button
                        class="choose-btn-next w-300 lg:j-w-206 px-0 font-700 lg:font-600"
                        data-advantage-add-to-cart
                        data-id="${product.goodsSkuId}"
                        data-goods-title="${product.goodsTitle}"
                        data-quantity="1"
                    >${howToChoose.addToCart} <i class="iconfont jackery-icon-arrow-right"></i></button>
                </p>
            </li>
        `
    }
    renderPlaceholder(type) {
        const { booking, } = this.fixedModelsPopup.dataset
        return `
            <li class="flex-[50%] rounded-20 lg:rounded-none bg-white">
                <div class="flex-center gap-8 lg:j-gap-20 lg:j-mb-4 text-primary">
                    <img loading="lazy" class="w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
                    <span class="text-32 leading-48 lg:j-text-24 lg:j-leading-36 font-300 lg:font-500">${type}</span>
                    <img loading="lazy" class="rotate-180 w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
                </div>
                <div class="flex-center flex-col gap-50 lg:j-gap-80">
                    <h2 class="text-32 leading-48 text-main font-600 lg:j-text-24 lg:j-leading-36">${howToChoose.comingSoon}</h2>
                    <img
                        loading="lazy"
                        class="block lg:hidden w-222 h-297 object-cover"
                        src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/no-result_mb.png?v=1678778753"
                        alt=""
                    />
                    <img
                        loading="lazy"
                        class="hidden lg:block lg:j-w-373 lh:j-h-199 object-cover"
                        src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/no-result_pc.png?v=1678778743"
                        alt=""
                    />
                    <a href="" class="choose-btn-back lg:j-mb-20">${booking} <i class="iconfont jackery-icon-arrow-right"></i></a>
                </div>
            </li>
        `
    }
    initOpenModelEvent() {
        const mask = this.fixedModelsPopup.querySelector('[data-mask]')
        const closeBtn = this.fixedModelsPopup.querySelector('[data-close]')
        mask.onclick = () => this.fixedModelsPopup.style.display = 'none'
        closeBtn.onclick = () => this.fixedModelsPopup.style.display = 'none'

        // 当前页面标题
        const title = document.querySelector('[data-title]').innerText

        document.querySelectorAll('[data-advantage-learn-more]').forEach( it => it.onclick = () => {
            // 数据埋码
            this.GAEvent({
                module: title,
                position: it.dataset.goodsTitle,
                button_name: it.innerText,
                link: it.getAttribute('href'),
            })
        })

        document.querySelectorAll('[data-advantage-add-to-cart]').forEach( it => it.onclick = () => {
            it.classList.add('btn--loading')
            const { id, quantity = 1, goodsTitle } = it.dataset
            this.addToCart(+id, +quantity)

            // 数据埋码
            this.GAEvent({
                module: title,
                position: goodsTitle,
                button_name: it.innerText,
            })
        })
    }
    chooseAdvantage(it) {
        const check = it.dataset.check
        if (check === '1') {
            it.checked = false
            it.dataset.check = '0'
        } else {
            it.checked = true
            it.dataset.check = '1'
        }

        const checkboxesArray = Array.from(this.advantageCheckboxes).map(it => it.checked)
        this.nextBtn.disabled = !checkboxesArray.includes(true)
    }
}
function initChooseAdvantages(totalEnergy) {
    const chooseAdvantages = new ChooseAdvantages({
        totalEnergy,

        prevEl: '#question2',
        el: '#question3',
        nextEl: '#question4',
    
        btnConfig: {
            backBtn: '[data-question3-back]',
            backBtnCallback: () => {
                chooseAdvantages.updateStep(2, 'prev')

                chooseAdvantages.clearAllBtn.style.display = 'block'
            },
            nextBtn: '[data-question3-next]',
            nextBtnCallback: () => {
                //  数据埋码
                const title = document.querySelector('[data-title]').innerText
                const advantageBoxes = chooseAdvantages.DOM.querySelectorAll('[data-advantage-checkbox]')
                Array.from(advantageBoxes).forEach(it => {
                    if (it.dataset.check === '1') {
                        const text = it.parentElement.nextElementSibling.innerText
                        chooseAdvantages.GAEvent({
                            module: title,
                            position: text,
                        })
                    }
                })

                chooseAdvantages.updateStep(4, 'next')

                const cycleCharging = document.querySelector('[data-type="sustainable-cycle-charging"]').checked
                if (!cycleCharging) {
                    // 初始化 选择太阳能板
                    const chooseSolarPanel = initChooseSolarPanel(false, totalEnergy)
                    chooseSolarPanel.nextBtn.onclick()
                } else {
                    initChooseSolarPanel(true, totalEnergy)
                }
            },
        },
    
        fixedModelsPopup: '#fixed-two-models-popup',
    })
    return chooseAdvantages
}


// 4 - 选择太阳能板
class ChooseSolarPanel extends BaseChoose {
    constructor({cycleCharging, totalEnergy, ...props }) {
        super(props)
        if (cycleCharging) {
            this.cycleCharging = cycleCharging
            this.totalEnergy = totalEnergy

            this.chargingDOM = this.$$('[data-charging-duration]')
            this.savingDOM = this.$$('[data-electric-saving]')
            this.checkoutPriceDOM = this.$$('[data-checkout-price]')

            this.portableOneDOM = this.$$('[data-portable="1"]')
            this.portableTwoDOM = this.$$('[data-portable="2"]')
            this.solarPanelsDOM = this.$$('[data-solar-panels-choose]')

            this.recommendedName = this.portableOneDOM.dataset.recommendedName
            this.deluxeName = this.portableTwoDOM.dataset.deluxeName

            this.portableOneDOM.innerHTML = this.renderPPSSkeleton(this.recommendedName)
            this.portableTwoDOM.innerHTML = this.renderPPSSkeleton(this.deluxeName)
            this.solarPanelsDOM.innerHTML = this.renderSPSKeleton()
            this.checkoutPriceDOM.innerHTML = this.renderPriceSkeleton()

            this.initDOM()
        }
    }
    async initDOM() {
        const { data:{ cusEnergyRespList = [], recommendSingleId, recommendPackageSolarId, deluxeSingleId, deluxePackageSolarId } }
            = await getBothGoods({ totalPower: this.totalEnergy, }) || {}
        // 选择 储能 + 太阳能面板 数据
        this.chooseParams = {
            recommendSingleId,
            recommendPackageSolarId,
            deluxeSingleId,
            deluxePackageSolarId,
        }
        this.cusEnergyRespList = cusEnergyRespList || []
        

        this.initPPS(this.cusEnergyRespList)

        const { singleId, cusSolarRespList = [], cusPriceResp, } = this.cusEnergyRespList[0] || {}

        // 0 表示 Recommended 推荐款
        this.initSolarPanels(0, singleId, cusSolarRespList)
        this.renderPrice(cusPriceResp)

        this.initEvent()
    }
    initPPS(cusEnergyRespList) {
        const RecommendedProduct = cusEnergyRespList.filter(it => it.recommend === 'smart_shop_recommend')[0]
        const recommendHTML = RecommendedProduct ? this.renderPPSProduct(this.recommendedName, RecommendedProduct) : this.renderPPSPlaceholder(this.recommendedName)
        this.portableOneDOM.innerHTML = recommendHTML
        if (RecommendedProduct) {
            this.portableOneDOM.classList.add('active')
        } else {
            this.portableOneDOM.classList.remove('active')
        }

        const deluxeProduct = cusEnergyRespList.filter(it => it.recommend === 'smart_shop_deluxe')[0]
        const deluxeDOMHTML = deluxeProduct ? this.renderPPSProduct(this.deluxeName, deluxeProduct) : this.renderPPSPlaceholder(this.deluxeName)
        this.portableTwoDOM.innerHTML = deluxeDOMHTML
        if (!RecommendedProduct && deluxeProduct) {
            this.portableTwoDOM.classList.add('active')
        } else {
            this.portableTwoDOM.classList.remove('active')
        }

        this.chooseParams.recommendSingleId = RecommendedProduct?.singleId || ''
        this.chooseParams.deluxeSingleId = deluxeProduct?.singleId || ''
    }
    initSolarPanels(type, singleId, cusSolarRespList = []) {
        let html = ''
        if (cusSolarRespList.length > 0) {
            cusSolarRespList.forEach(({ defaultPackageSolarId, goodsSolarTitle, goodsSolarImage, solarNumRespList = []}, index) => {
                let activeIndex = ''
                let activeStarIndex = 0
                const activePackageSolarId =
                    type === 0 ? this.chooseParams.recommendPackageSolarId : this.chooseParams.deluxePackageSolarId

                let optionsHTML = ''
                solarNumRespList.forEach((it, idx) => {
                    // 第一次取默认的值，之后取改变后的值
                    const packageSolarId = activeIndex === '' ? defaultPackageSolarId : activePackageSolarId

                    optionsHTML += `
                        <option
                            class="text-center"
                            value="${it.packageSolarId}"
                            ${it.packageSolarId === packageSolarId ? 'selected' : ''}
                            data-single-id="${singleId}"
                            data-type="${type}"
                            ${it.solarNum === 0 ? 'disabled' : ''}
                        >${it.solarNum}</option>
                    `

                    if (it.packageSolarId === packageSolarId) {
                        activeStarIndex = idx
                    }
                    if (it.packageSolarId === activePackageSolarId) {
                        activeIndex = index
                    }
                })
                const performance = solarNumRespList[activeStarIndex]?.performance || 0
                const starsHTML = this.renderStar(performance)


                html += `
                    <li class="group ${activeIndex === index ? 'active' : ''}" data-solar="${index + 1}" data-goods-title="${goodsSolarTitle}">
                        <div class="group-[.active]:border-primary h-full flex-between flex-col pl-65 pr-20 pt-20 pb-12 rounded-30 lg:j-rounded-30 border-4 lg:j-border-3 border-solid border-input lg:j-px-24 lg:j-py-20 bg-white cursor-pointer">
                            <h4 class="group-[.active]:text-black text-info font-500 text-26 leading-30 lg:j-text-18 lg:j-leading-27 lg:font-300">${goodsSolarTitle}</h4>
                            <div class="w-full flex flex-row lg:flex-col items-center justify-between mt-8">
                                <img loading="lazy" class="w-220 h-96 lg:j-w-200 lg:j-h-120 object-contain group-[.active]:opacity-100 opacity-50" src="${goodsSolarImage}" alt="">
                                <div class="lg:w-full flex-between gap-12 lg:j-mt-8 lg:flex-row-reverse">
                                    <select class="choose-select-number" name="select-solar-panel-number">${optionsHTML}</select>
                                    <span class="flex gap-4 lg:j-gap-4 w-120 lg:j-w-120">${starsHTML}</span>
                                </div>
                            </div>
                        </div>
                    </li>
                `
            })
        } else {
            html += this.renderSPPlaceholder()
        }
        this.solarPanelsDOM.innerHTML = html

        document.querySelectorAll('[name="select-solar-panel-number"]')
            .forEach(it => it.onchange = () => this.handleSelectChange(it))
    }
    renderNumSkeleton(width) {
        return `<div class="inline-block w-${width} h-48 lg:j-w-${width} lg:j-h-36 align-middle mx-2 bg-[#EEE] skeleton"></div>`
    }
    renderPPSSkeleton(type) {
        return `
            <div class="flex-center gap-8 lg:j-gap-20 mb-3">
                <img loading="lazy" class="block group-[.active]:hidden w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAhFBMVEUAAACZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiYmJiZmZmYmJicnJyYmJiZmZmZmZmampqZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiYmJiZmZmYmJiampqYmJiYmJiYmJiZmZmZmZmVlZWYmJiUlJSVlZWYmJiZmZmZmZmGdBRsAAAAK3RSTlMA6cy2rqGZkIh7clk7KhkMZt7YYPj07+PSxcG9gWxSTkpGQjUwJB8TBqin2EV90gAAAFdJREFUGNNjYNDg51fn41NT5eVVUebhUVJUkJfj5hYWEJDl4uLklOHgYGdnY2Nl1WRhYWaWlpJkYpIQEhIUZ2QUExXRZgADbSAgxxhB4o0RRjNGiy6uAQDTXhM7RLywWQAAAABJRU5ErkJggg=='/>
                <img loading="lazy" class="hidden group-[.active]:block w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
                <span class="text-26 lg:j-text-24 lg:j-leading-36 font-300 lg:font-500 text-info group-[.active]:text-primary">${type}</span>
                <img loading="lazy" class="block group-[.active]:hidden rotate-180 w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAhFBMVEUAAACZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiYmJiZmZmYmJicnJyYmJiZmZmZmZmampqZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiYmJiZmZmYmJiampqYmJiYmJiYmJiZmZmZmZmVlZWYmJiUlJSVlZWYmJiZmZmZmZmGdBRsAAAAK3RSTlMA6cy2rqGZkIh7clk7KhkMZt7YYPj07+PSxcG9gWxSTkpGQjUwJB8TBqin2EV90gAAAFdJREFUGNNjYNDg51fn41NT5eVVUebhUVJUkJfj5hYWEJDl4uLklOHgYGdnY2Nl1WRhYWaWlpJkYpIQEhIUZ2QUExXRZgADbSAgxxhB4o0RRjNGiy6uAQDTXhM7RLywWQAAAABJRU5ErkJggg=='/>
                <img loading="lazy" class="hidden group-[.active]:block rotate-180 w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
            </div>
            <div class="w-307 h-300 lg:j-w-545 lg:j-h-90 rounded-60 lg:j-rounded-30 bg-[#EEE] skeleton"></div>
        `
    }
    renderSPSKeleton() {
        return `
            <li>
                <div class="w-full h-168 lg:j-h-240 rounded-30 lg:j-rounded-30 bg-[#EEE] skeleton"></div>
            </li>
            <li>
                <div class="w-full h-168 lg:j-h-240 rounded-30 lg:j-rounded-30 bg-[#EEE] skeleton"></div>
            </li>
            <li>
                <div class="w-full h-168 lg:j-h-240 rounded-30 lg:j-rounded-30 bg-[#EEE] skeleton"></div>
            </li>
        `
    }
    renderPriceSkeleton() {
        return `
            <div class="w-full flex items-center justify-center lg:justify-between lg:j-mt-12 mb-15 lg:j-mb-15">
                <div class="w-[70%] h-30 lg:j-w-565 lg:j-h-27 bg-[#EEE] skeleton"></div>
                <div class="w-[25%] h-30 lg:j-w-240 lg:j-h-27 bg-[#EEE] skeleton"></div>
            </div>
            <div class="w-full flex items-center justify-center lg:justify-between mb-15 lg:j-mb-15">
                <div class="w-[70%] h-30 lg:j-w-565 lg:j-h-27 bg-[#EEE] skeleton"></div>
                <div class="w-[25%] h-30 lg:j-w-240 lg:j-h-27 bg-[#EEE] skeleton"></div>
            </div>
        `
    }
    renderPrice({ chargingDuration, powerSaving, coordinatesType, priceCoordinatesResp = {}, priceSingleResp = {}, priceSolarResp = {}, goodsAllPrice, goodsAllOriginalPrice }) {
        this.chargingDOM.innerHTML = chargingDuration || 0
        this.savingDOM.innerHTML = powerSaving || 0

        let html = ''
        // 如果是套装
        if (coordinatesType) {
            html = this.renderCoordinatesPriceDOM(priceCoordinatesResp || {})
        } else {
            html += this.renderPriceDOM(priceSingleResp || {})
            html += this.renderPriceDOM(priceSolarResp || {}, 'solar')
            html += `
                <div class="w-[120%] lg:j-w-1110 scale-[0.833333333] lg:scale-100 origin-left flex items-center justify-center lg:justify-end gap-20 lg:j-gap-20 mt-15 lg:mt-0 mb-25 lg:j-mb-40">
                    <span class="text-primary text-36 leading-54 lg:j-text-24 lg:j-leading-36 font-600">Total: ${formatMoney(goodsAllPrice * 100, window?.pageInfo?.currency?.money_format)}</span>
                    ${goodsAllOriginalPrice
                        ? `<del class="text-info text-24 leading-36 lg:j-text-18 lg:j-leading-27 font-300">${formatMoney(goodsAllOriginalPrice * 100, window?.pageInfo?.currency?.money_format)}</del>`
                        : ''
                    }
                </div>
            `
        }

        this.checkoutPriceDOM.innerHTML = html
    }
    // 渲染 价格
    renderPriceDOM(product = {}, type) {
        if (!Object.keys(product).length) return ''
        return `
            <p class="w-[120%] lg:j-w-1110 scale-[0.833333333] lg:scale-100 origin-left flex items-center justify-between">
                <span class="text-black lg:text-main text-24 leading-30 lg:j-text-18 lg:j-leading-27 inline-block font-600 lg:font-300 w-[70%]">${product.goodsTitle}${type === 'solar' ? ` × ${product.solarNum}` : ''}</span>
                <span class="text-primary text-24 leading-30 lg:j-text-24 lg:j-leading-36 inline-block font-600 w-[25%] text-right">${formatMoney(product.goodsPrice * 100, window?.pageInfo?.currency?.money_format)}${type === 'solar' ? ` × ${product.solarNum}` : ''}</span>
            </p>
        `
    }
    // 渲染套装 价格
    renderCoordinatesPriceDOM(product = {}) {
        if (!Object.keys(product).length) return ''
        return `
            <div class="w-full lg:j-w-1110 flex-center flex-col lg:flex-row lg:justify-between">
                <div class="flex flex-col lg:flex-row">
                    <p class="text-center text-24 leading-30 text-black lg:j-text-18 lg:j-leading-27 lg:text-main font-300">${product.goodsTitle}</p>
                </div>
                <p class="flex items-center gap-12 lg:j-gap-24 mt-15 lg:mt-0">
                    <span class="text-primary text-36 leading-54 lg:j-text-24 lg:j-leading-36 font-600">${formatMoney(product.goodsPrice * 100, window?.pageInfo?.currency?.money_format)}</span>
                    ${product.goodsOriginalPrice
                        ? `<del class="text-info text-24 leading-30 lg:j-text-18 lg:j-leading-27 font-300">${formatMoney(product.goodsOriginalPrice * 100, window?.pageInfo?.currency?.money_format)}</del>`
                        : ''
                    }
                </p>
            </div>
        `
    }
    renderPPSProduct(type, product) {
        return `
            <div class="flex-center gap-8 lg:j-gap-20 mb-3">
                <img loading="lazy" class="block group-[.active]:hidden w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAhFBMVEUAAACZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiYmJiZmZmYmJicnJyYmJiZmZmZmZmampqZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiYmJiZmZmYmJiampqYmJiYmJiYmJiZmZmZmZmVlZWYmJiUlJSVlZWYmJiZmZmZmZmGdBRsAAAAK3RSTlMA6cy2rqGZkIh7clk7KhkMZt7YYPj07+PSxcG9gWxSTkpGQjUwJB8TBqin2EV90gAAAFdJREFUGNNjYNDg51fn41NT5eVVUebhUVJUkJfj5hYWEJDl4uLklOHgYGdnY2Nl1WRhYWaWlpJkYpIQEhIUZ2QUExXRZgADbSAgxxhB4o0RRjNGiy6uAQDTXhM7RLywWQAAAABJRU5ErkJggg=='/>
                <img loading="lazy" class="hidden group-[.active]:block w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
                <span class="text-26 lg:j-text-24 lg:j-leading-36 font-300 lg:font-500 text-info group-[.active]:text-primary">${type}</span>
                <img loading="lazy" class="block group-[.active]:hidden rotate-180 w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAhFBMVEUAAACZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiYmJiZmZmYmJicnJyYmJiZmZmZmZmampqZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiYmJiZmZmYmJiampqYmJiYmJiYmJiZmZmZmZmVlZWYmJiUlJSVlZWYmJiZmZmZmZmGdBRsAAAAK3RSTlMA6cy2rqGZkIh7clk7KhkMZt7YYPj07+PSxcG9gWxSTkpGQjUwJB8TBqin2EV90gAAAFdJREFUGNNjYNDg51fn41NT5eVVUebhUVJUkJfj5hYWEJDl4uLklOHgYGdnY2Nl1WRhYWaWlpJkYpIQEhIUZ2QUExXRZgADbSAgxxhB4o0RRjNGiy6uAQDTXhM7RLywWQAAAABJRU5ErkJggg=='/>
                <img loading="lazy" class="hidden group-[.active]:block rotate-180 w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
            </div>
            <div class="w-307 h-300 lg:j-w-545 lg:j-h-90 flex-center flex-col lg:flex-row lg:j-gap-12 py-24 lg:j-py-12 border-4 lg:j-border-3 border-input border-solid rounded-60 lg:j-rounded-30 cursor-pointer group-[.active]:border-primary">
                <img loading="lazy" class="object-cover w-160 h-160 lg:j-w-60 lg:j-h-60" src="${product.goodsImage}" />
                <span
                    class="line-clamp-2 lg:line-clamp-1 text-26 leading-36 lg:j-text-24 lg:j-leading-36 font-500 text-main text-center mt-15 lg:mt-0" style="max-width:80%;"
                    title="${product.goodsTitle}"
                    data-goods-title="${product.goodsTitle}"
                >${product.goodsTitle}</span>
            </div>
        `
    }
    renderPPSPlaceholder(type) {
        return `
            <div class="flex-center gap-8 lg:j-gap-20 mb-3 group-[.active]:text-primary">
                <img loading="lazy" class="block group-[.active]:hidden w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAhFBMVEUAAACZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiYmJiZmZmYmJicnJyYmJiZmZmZmZmampqZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiYmJiZmZmYmJiampqYmJiYmJiYmJiZmZmZmZmVlZWYmJiUlJSVlZWYmJiZmZmZmZmGdBRsAAAAK3RSTlMA6cy2rqGZkIh7clk7KhkMZt7YYPj07+PSxcG9gWxSTkpGQjUwJB8TBqin2EV90gAAAFdJREFUGNNjYNDg51fn41NT5eVVUebhUVJUkJfj5hYWEJDl4uLklOHgYGdnY2Nl1WRhYWaWlpJkYpIQEhIUZ2QUExXRZgADbSAgxxhB4o0RRjNGiy6uAQDTXhM7RLywWQAAAABJRU5ErkJggg=='/>
                <img loading="lazy" class="hidden group-[.active]:block w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
                <span class="text-26 lg:j-text-24 lg:j-leading-36 font-300 lg:font-500">${type}</span>
                <img loading="lazy" class="block group-[.active]:hidden rotate-180 w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAhFBMVEUAAACZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiYmJiZmZmYmJicnJyYmJiZmZmZmZmampqZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiYmJiZmZmYmJiampqYmJiYmJiYmJiZmZmZmZmVlZWYmJiUlJSVlZWYmJiZmZmZmZmGdBRsAAAAK3RSTlMA6cy2rqGZkIh7clk7KhkMZt7YYPj07+PSxcG9gWxSTkpGQjUwJB8TBqin2EV90gAAAFdJREFUGNNjYNDg51fn41NT5eVVUebhUVJUkJfj5hYWEJDl4uLklOHgYGdnY2Nl1WRhYWaWlpJkYpIQEhIUZ2QUExXRZgADbSAgxxhB4o0RRjNGiy6uAQDTXhM7RLywWQAAAABJRU5ErkJggg=='/>
                <img loading="lazy" class="hidden group-[.active]:block rotate-180 w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
            </div>
            <div
                class="w-307 h-300 lg:j-w-545 lg:j-h-90 flex-center flex-col lg:flex-row lg:j-gap-12 py-24 lg:j-py-12 border-4 lg:j-border-3 border-disabled border-solid rounded-60 lg:j-rounded-30 cursor-pointer group-[.active]:border-primary"
                data-disabled="disabled"
            >
                <div class="w-160 h-160 lg:j-w-60 lg:j-h-60"></div>
            </div>
        `
    }
    renderSPPlaceholder() {
        return `
            <li class="group hidden lg:block">
                <div class="w-full h-584 lg:j-h-240 flex items-center flex-col rounded-30 lg:j-rounded-30 bg-transparent pt-20 pb-12 lg:j-py-20">
                </div>
            </li>
            <li class="group">
                <div class="w-full h-584 lg:j-h-240 flex items-center flex-col rounded-30 lg:j-rounded-30 bg-white pt-20 pb-12 lg:j-py-20 border-4 lg:j-border-3 border-solid border-input">
                    <h2 class="font-500 text-26 leading-30 lg:j-text-18 lg:j-leading-27 lg:font-300 mt-30 lg:mt-0 mb-90 lg:j-mb-30">${howToChoose.comingSoon}</h2>
                    <img
                        loading="lazy"
                        class="block lg:hidden w-222 h-297 object-cover"
                        src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/no-result_mb.png?v=1678778753"
                        alt=""
                    />
                    <img
                        loading="lazy"
                        class="hidden lg:block lg:j-w-200 lg:j-h-120 object-cover"
                        src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/no-result_pc.png?v=1678778743"
                        alt=""
                    />
                </div>
            </li>
        `
    }
    initEvent() {
        this.portablePowers = this.DOM.querySelectorAll('[data-portable]') || []
        this.solarPanels = this.DOM.querySelectorAll('[data-solar]') || []

        this.portablePowers.forEach((it, idx) => it.onclick = () => this.initTab('portable', it, idx))
        this.solarPanels.forEach(it => it.onclick = () => this.initTab('solar', it))
    }
    initTab(type, it, idx) {
        if (it.lastElementChild.dataset.disabled === 'disabled') return false
        if (type === 'portable') {
            if (!it.classList.contains('active')) {
                const { singleId, cusSolarRespList = [], } = this.cusEnergyRespList[idx] || {}

                this.initSolarPanels(idx, singleId, cusSolarRespList)
                const packageSolarId = idx === 0 ? this.chooseParams.recommendPackageSolarId : this.chooseParams.deluxePackageSolarId
                
                this.chargingDOM.innerHTML = this.renderNumSkeleton(50)
                this.savingDOM.innerHTML = this.renderNumSkeleton(100)
                
                if (singleId) {
                    this.checkoutPriceDOM.innerHTML = this.renderPriceSkeleton()
                    getBothGoodsPrice({ singleId, packageSolarId, })
                        .then(({ data }) => {
                            this.renderPrice(data)
                        })
                        .catch(() => {})
                }

                this.initEvent()
            }

            this.portablePowers.forEach(v => v.classList.remove('active'))
            it.classList.add('active')
        }
        if (type === 'solar') {
            if (!it.classList.contains('active')) {
                const solarSelectDOM = it.querySelector('[name="select-solar-panel-number"]')
                this.handleSelectChange(solarSelectDOM)
            }
            this.solarPanels.forEach(v => v.classList.remove('active'))
            it.classList.add('active')
        }
    }
    // 渲染 star DOM
    renderStar(number = 0) {
        let html = ''
        Array(number).fill('').forEach(_ => html += `<i class="choose-star"></i>`)
        return html
    }
    async handleSelectChange(it) {
        const selectedIndex = it.selectedIndex || 0
        const packageSolarId = it.options[selectedIndex].value
        const { singleId, type } = it.options[selectedIndex].dataset

        this.chargingDOM.innerHTML = this.renderNumSkeleton(50)
        this.savingDOM.innerHTML = this.renderNumSkeleton(100)
        this.checkoutPriceDOM.innerHTML = this.renderPriceSkeleton()

        const { data: { performance, ...props} } = await getBothGoodsPrice({ singleId, packageSolarId, }) || {}
        it.nextElementSibling.innerHTML = this.renderStar(performance)
        this.renderPrice({ ...props })

        // 推荐
        if (type === '0') {
            this.chooseParams.recommendPackageSolarId = packageSolarId
        } else {
            this.chooseParams.deluxePackageSolarId = packageSolarId
        }
    }
}
function initChooseSolarPanel(cycleCharging, totalEnergy) {
    const chooseSolarPanel =  new ChooseSolarPanel({
        cycleCharging,
        totalEnergy,

        prevEl: '#question3',
        el: '#question4',
        nextEl: '#end',
    
        btnConfig: {
            backBtn: '[data-question4-back]',
            backBtnCallback: () => {
                chooseSolarPanel.updateStep(3, 'prev')
            },
            nextBtn: '[data-question4-next]',
            nextBtnCallback: () => {
                //  数据埋码
                const title = document.querySelector('[data-title]').innerText
                const activePortable = Array.from(chooseSolarPanel.portablePowers)?.find(it => it.classList?.contains('active'))
                const portableTitle = activePortable?.querySelector('[data-goods-title]')?.innerText

                const activeSolar = Array.from(chooseSolarPanel.solarPanels)?.find(it => it.classList?.contains('active'))
                const solarTitle = activeSolar?.dataset?.goodsTitle
                const number = Array.from(activeSolar?.querySelectorAll('[data-type]'))?.find(it => it.selected)?.innerText
                chooseSolarPanel.GAEvent({
                    module: title,
                    position: portableTitle,
                    button_name: `${solarTitle} * ${number}`
                })

                chooseSolarPanel.updateStep(5, 'next')

                // 初始化 End Choose
                initEndChoose(cycleCharging, totalEnergy, chooseSolarPanel.chooseParams)
            },
        },
    })
    return chooseSolarPanel
}


// 5 - 结果
class EndChoose extends BaseChoose {
    constructor({ cycleCharging, totalEnergy, chooseParams, tryAgainBtn, ...props }) {
        super(props)

        this.goodsResultDOM = this.$$('[data-goods-result]')
        this.tryAgainDOM = this.$$(tryAgainBtn)

        this.recommendedName = this.goodsResultDOM.dataset.recommendedName
        this.deluxeName = this.goodsResultDOM.dataset.deluxeName

        !cycleCharging ? this.renderSingleDOM(totalEnergy) : this.renderListDOM(chooseParams)

        this.initEvent()
    }
    // 渲染 单品
    async renderSingleDOM(totalPower) {
        const { data: {cusEnergyRespList = []} } = await getResultSingleGoods({ totalPower, }) || {}

        const RecommendedProduct = (cusEnergyRespList || []).filter(it => it.recommend === 'smart_shop_recommend')[0]
        const recommendHTML = RecommendedProduct ? this.renderSingleProduct(this.recommendedName, RecommendedProduct) : this.renderPlaceholder(this.recommendedName)

        const deluxeProduct = (cusEnergyRespList || []).filter(it => it.recommend === 'smart_shop_deluxe')[0]
        const deluxeHTML = deluxeProduct ? this.renderSingleProduct(this.deluxeName, deluxeProduct) : this.renderPlaceholder(this.deluxeName)

        this.goodsResultDOM.innerHTML = recommendHTML + deluxeHTML

        // 当前页面标题
        const title = document.querySelector('[data-title]').innerText

        document.querySelectorAll('[data-end-learn-more]').forEach( it => it.onclick = () => {
            // 数据埋码
            this.GAEvent({
                module: title,
                position: it.dataset.goodsTitle,
                button_name: it.innerText,
                link: it.getAttribute('href'),
            })
        })

        document.querySelectorAll('[data-end-buy-now]').forEach( it => it.onclick = () => {
            it.classList.add('btn--loading')
            const { id, goodsTitle } = it.dataset
            this.buyNow(+id)

            // 数据埋码
            this.GAEvent({
                module: title,
                position: goodsTitle,
                button_name: it.innerText,
            })
        })
    }
    renderSingleProduct(type, product) {
        const { learnMore, } = this.goodsResultDOM.dataset
        return `
            <li class="flex-[50%] rounded-20 lg:rounded-none bg-white py-48 px-40 shadow-[0px_0.8vw_2.8vw_0px_rgba(203,203,203,0.5)] lg:shadow-none lg:j-px-77 lg:j-pt-24 lg:pb-12">
                <div class="flex-center gap-8 lg:j-gap-20 mb-4 lg:mb-1 text-primary">
                    <img loading="lazy" class="w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
                    <span class="text-26 lg:j-text-24 lg:j-leading-36 font-300 lg:font-500">${type}</span>
                    <img loading="lazy" class="rotate-180 w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
                </div>
                <div class="flex-center flex-col">
                    <h2 class="w-full text-center text-32 leading-54 lg:j-text-24 lg:j-leading-36 font-500 text-main line-clamp-2 text-ellipsis" title="${product.goodsTitle}">${product.goodsTitle}</h2>
                    <img
                        loading="lazy"
                        class="w-315 h-190 lg:j-w-315 lg:j-h-190 object-contain mt-50 mb-25 lg:j-mt-50 lg:j-mb-24"
                        src="${product.goodsImage}"
                        alt=""
                    />
                    <p class="flex items-center gap-20">
                        <span class="text-36 leading-54 font-600 text-primary lg:j-text-36 lg:j-leading-54">${formatMoney(product.goodsPrice * 100, window?.pageInfo?.currency?.money_format)}</span>
                        ${product.goodsOriginalPrice
                            ? `<del class="text-24 leading-36 lg:j-text-18 lg:j-leading-27 font-300 text-sub">${formatMoney(product.goodsOriginalPrice * 100, window?.pageInfo?.currency?.money_format)}</del>`
                            : ''
                        }
                    </p>
                </div>
                <p class="flex-between lg:justify-center mt-50 lg:j-mt-40 gap-30 lg:j-gap-24">
                    <a
                        href="${product.goodsDetailUrl}"
                        target="_blank" class="choose-btn-back w-255 lg:j-w-206 px-0"
                        data-end-learn-more
                        data-goods-title="${product.goodsTitle}"
                    >${learnMore} <i class="iconfont jackery-icon-arrow-right"></i></a>
                    <button
                        class="choose-btn-next w-255 lg:j-w-206 px-0"
                        data-id="${product.goodsSkuId}"
                        data-goods-title="${product.goodsTitle}"
                        data-end-buy-now
                    >BUY NOW <i class="iconfont jackery-icon-arrow-right"></i></button>
                </p>
            </li>
        `
    }
    renderPlaceholder(type) {
        const { booking, } = this.goodsResultDOM.dataset
        return `
            <li class="flex-[50%] rounded-20 lg:rounded-none bg-white py-48 shadow-[0px_0.8vw_2.8vw_0px_rgba(203,203,203,0.5)] lg:shadow-none lg:j-px-32 lg:j-py-24">
                <div class="flex-center gap-8 lg:j-gap-20 mb-3 text-primary">
                    <img loading="lazy" class="w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
                    <span class="text-26 lg:j-text-24 lg:j-leading-36 font-300 lg:font-500">${type}</span>
                    <img loading="lazy" class="rotate-180 w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
                </div>
                <div class="flex-center flex-col gap-50 lg:j-gap-80">
                    <h2 class="text-32 leading-48 text-main font-600 lg:j-text-24 lg:j-leading-36">${howToChoose.comingSoon}</h2>
                    <img
                        loading="lazy"
                        class="block lg:hidden w-222 h-297 object-cover"
                        src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/no-result_mb.png?v=1678778753"
                        alt=""
                    />
                    <img
                        loading="lazy"
                        class="hidden lg:block lg:j-w-373 lg:j-h-199 object-cover"
                        src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/no-result_pc.png?v=1678778743"
                        alt=""
                    />
                    <a href="" class="choose-btn-back lg:j-mb-20">${booking} <i class="iconfont jackery-icon-arrow-right"></i></a>
                </div>
            </li>
        `
    }
    async renderListDOM(chooseParams) {
        const { data: {
            recommendGoodsAllPrice,
            recommendGoodsDetailResps = [],
            deluxeGoodsAllPrice,
            deluxeGoodsDetailResps = [],
            recommendCoordinatesType, // 是否 推荐套装
            deluxeCoordinatesType, // 是否 豪华套装
        } }
            = await getResultGoodsList({ ...chooseParams})
        
        const recommendHTML = recommendGoodsDetailResps.length ?
            recommendCoordinatesType
                ? this.renderSingleProduct(this.recommendedName, recommendGoodsDetailResps[0]) 
                : this.renderProductList(this.recommendedName, recommendGoodsAllPrice, recommendGoodsDetailResps)
                    : this.renderPlaceholder(this.recommendedName)

        const deluxeHTML = deluxeGoodsDetailResps.length ?
            deluxeCoordinatesType
                ? this.renderSingleProduct(this.deluxeName, deluxeGoodsDetailResps[0])
                : this.renderProductList(this.deluxeName, deluxeGoodsAllPrice, deluxeGoodsDetailResps)
                    : this.renderPlaceholder(this.deluxeName)
    
        this.goodsResultDOM.innerHTML = recommendHTML + deluxeHTML

        // 当前页面标题
        const title = document.querySelector('[data-title]').innerText

        document.querySelectorAll('[data-end-add-to-cart]').forEach( it => it.onclick = () => {
            it.classList.add('btn--loading')
            const { id, quantity = 1, goodsTitle } = it.dataset
            this.addToCart(+id, +quantity)

            // 数据埋码
            this.GAEvent({
                module: title,
                position: goodsTitle,
                button_name: it.innerText,
            })
        })

        document.querySelectorAll('[data-end-learn-more]').forEach( it => it.onclick = () => {
            // 数据埋码
            this.GAEvent({
                module: title,
                position: it.dataset.goodsTitle,
                button_name: it.innerText,
                link: it.getAttribute('href'),
            })
        })

        document.querySelectorAll('[data-end-buy-now]').forEach( it => it.onclick = () => {
            it.classList.add('btn--loading')
            const { id, goodsTitle } = it.dataset
            this.buyNow(+id)

            // 数据埋码
            this.GAEvent({
                module: title,
                position: goodsTitle,
                button_name: it.innerText,
            })
        })
    }
    renderProductList(type, totalPrice, products) {
        let html = `
            <div class="flex-center gap-8 lg:j-gap-20 mb-3 text-primary">
                <img loading="lazy" class="w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
                <span class="text-26 lg:j-text-24 lg:j-leading-36 font-300 lg:font-500">${type}</span>
                <img loading="lazy" class="rotate-180 w-50 h-4 lg:w-auto lg:h-auto" src='data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAECAMAAAAEYLnRAAAAolBMVEUAAAD0WQDzWgDzWgD0WgD2WQDxUgDyWQD0WQD0WgD0WQDzWgDzWQDzWgDzWgDzWgDyWQDzWgDzWQDzWgDzWQDzWgDzWgDzWgDzWQDzWgDzWQDzWgDzWQDzWgD0WQDyWgDyWQDzWQDzWgDzWADzWQDzWAD0WQD1WADyWgDxVwDyWQDyWgDyWQDxVwDyWQDzVwDyWQDxVQDxWAD/UwD/VQD9UABoi6O5AAAANXRSTlMAtqF/XRkReHH9+PTw7Ofj39vW0s7KxcG8sKyom5eSjoqGbGhkV1JOSkZCPTk1MCwoJB8LBg4lTz4AAABTSURBVBjTY2AwMWZjY2U1MjTQ19PV0dbS1FBXU2VhUVFW4uBgZ2ZWVJCXk5VhYpKWkmRklBAXExURFhIU4Ofj5eHm4mQAA1MgwGcMO/HGDC7XAAB4ABlLZzm0lwAAAABJRU5ErkJggg=='/>
            </div>
        `

        products.forEach(({ goodsImage, goodsTitle, goodsSkuId, goodsPrice, solarNum}, index) => {
            html += `
                ${index === 1 ? '<div class="w-full h-[1px] lg:j-h-20 bg-[#EEEEEE] lg:bg-transparent my-27 lg:my-0"></div>' : ''}
                <div class="flex flex-row gap-20 lg:j-gap-24">
                    <img loading="lazy" class="w-180 h-180 lg:j-w-200 lg:j-h-200 object-contain" src="${goodsImage}" alt="">
                    <div class="flex-1">
                        <h2 class="w-full h-72 lg:j-h-72 text-24 leading-36 lg:j-text-24 lg:j-leading-36 font-500 text-black lg:text-main line-clamp-2 text-ellipsis" title="${goodsTitle}">${goodsTitle}</h2>
                        <p class="text-26 leading-39 lg:j-text-24 lg:j-leading-36 font-400 text-main lg:text-sub mb-35 lg:j-mb-12">${formatMoney(goodsPrice * 100, window?.pageInfo?.currency?.money_format)} ${solarNum ? `× ${solarNum}` : ''}</p>
                        <button
                            class="choose-btn-next"
                            data-end-add-to-cart
                            data-goods-title="${goodsTitle}"
                            data-id="${goodsSkuId}"
                            data-quantity="${solarNum || 1}"
                        >${howToChoose.addToCart} <i class="iconfont jackery-icon-arrow-right"></i></button>
                    </div>
                </div>
                ${index === 1 ? `<p class="text-36 leading-54 font-600 text-primary text-center mt-27 lg:j-mt-16 lg:j-text-36 lg:j-leading-54">Total:${formatMoney(totalPrice * 100, window?.pageInfo?.currency?.money_format)}</p>` : ''}
            `
        })
        return `
            <li class="flex-[50%] rounded-20 lg:rounded-none bg-white py-18 pl-40 pr-18 shadow-[0px_0.8vw_2.8vw_0px_rgba(203,203,203,0.5)] lg:shadow-none lg:j-px-32 lg:j-py-24">
                ${html}
            </li>
        `
    }
    initEvent() {
        // 当前页面标题
        const title = document.querySelector('[data-title]').innerText

        document.querySelector('[data-pps-link]').onclick = e => {
            // 数据埋码
            this.GAEvent({
                module: title,
                position: e.target.nodeName === 'A' ? e.target.innerText : e.target.parentElement.innerText,
                link: e.target.nodeName === 'A' ? e.target.getAttribute('href') : e.target.parentElement.getAttribute('href')
            })
        }
        document.querySelector('[data-sp-link]').onclick = e => {
            // 数据埋码
            this.GAEvent({
                module: title,
                position: e.target.nodeName === 'A' ? e.target.innerText : e.target.parentElement.innerText,
                link: e.target.nodeName === 'A' ? e.target.getAttribute('href') : e.target.parentElement.getAttribute('href')
            })
        }
        this.tryAgainDOM.onclick = e => {
            // 数据埋码
            this.GAEvent({
                module: title,
                position: '',
                button_name: e.target.nodeName === 'BUTTON' ? e.target.innerText : e.target.parentElement.innerText
            })

            this.scrollToHelpMeDOM(() => {
                setTimeout(() => location.reload(), 300);
            })
        }
    }
}
function initEndChoose(cycleCharging, totalEnergy, chooseParams) {
    const endChoose = new EndChoose({
        cycleCharging,
        totalEnergy,
        chooseParams,

        prevEl: '#question4',
        el: '#end',

        btnConfig: {
            backBtn: '[data-question5-back]',
            backBtnCallback: () => {
                if (!cycleCharging) {
                    document.querySelector('[data-question4-back]').onclick()
                    endChoose.updateStep(3, 'prev')
                } else {
                    endChoose.updateStep(4, 'prev')
                }
            },
        },

        tryAgainBtn: '[data-end-try-again]',
    })
    return endChoose
}